import Button from '@asphalt-react/button';
import Flag from '@asphalt-react/flag';
import { Search } from '@asphalt-react/textfield';
import { Controls, Player } from '@lottiefiles/react-lottie-player';
import cn from 'classnames';
import firebase from 'firebase/app';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { Link, useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import Permission from '../../authorization/components/Permission';
import actions from '../../authorization/models/actions';
import ConfigProvider from '../../common/components/ConfigProvider';
import NoSearchResultsFound from '../../common/components/NoSearchResultsFound';
import configKeys from '../../common/models/config-keys';
import routes from '../../common/models/route-constants';
import styles from './AnimatedIconHomePage.module.css';

function AnimatedIconHomePage() {
  let { path } = useRouteMatch();
  let history = useHistory();
  const location = useLocation();
  const [animatedIcons, setAnimatedIcons] = useState([]);
  const [notification, setNotification] = useState(null);
  const [filteredAnimatedIcons, setFilteredAnimatedIcons] = useState([]);
  const [filterString, setFilterString] = useState('');

  const clearHistoryNotificationState = (history) => {
    let state = { ...history.location.state };
    delete state.notification;
    history.replace({
      ...history.location,
      state,
    });
  };

  const filter = _.debounce((term) => {
    setFilterString(term);
    filterList(term);
  }, 300);

  const filterList = (inputFilterString) => {
    if (_.isEmpty(inputFilterString)) {
      setFilteredAnimatedIcons(animatedIcons);
      return;
    }
    // constructing the regex string for case-insensitive matching
    var regex = new RegExp(_.escapeRegExp(inputFilterString), 'i');

    setFilteredAnimatedIcons(
      _.filter(animatedIcons, (illustration) => {
        return illustration.data().combined_name.match(regex);
      })
    );
  };

  useEffect(() => {
    if (location.state && location['state'].notification) {
      setNotification(location.state.notification);
    }

    // set listener
    var db = firebase.firestore();
    const unsubscribeGetAllIconsListener = db
      .collection('animated_icons')
      .orderBy('created_at', 'desc')
      .onSnapshot(
        function (snapshot) {
          setAnimatedIcons(snapshot.docs);
          if (_.isEmpty(filterString)) {
            setFilteredAnimatedIcons(snapshot.docs);
          }
        },
        function (error) {
          throw error;
        }
      );
    return () => {
      unsubscribeGetAllIconsListener();
    };
  }, [history, location, filterString]);

  function getAnimatedIconView(doc) {
    return (
      <span
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}>
        <Player
          autoplay={false}
          loop
          src={doc.data().img_url}
          className={styles.animPlayer}>
          <Controls
            visible={true}
            transparentTheme={true}
            buttons={['play', 'repeat', 'frame', 'debug']}
          />
        </Player>
      </span>
    );
  }

  function getAnimatedIconItem(doc) {
    return (
      <Link
        to={`${path}/${doc.id}`}
        key={doc.data().combined_name}
        className={styles.illustrationCard}>
        <p className={styles.illustrationName}>{doc.data().combined_name}</p>
        <div className={styles.imageContainer}>{getAnimatedIconView(doc)}</div>
      </Link>
    );
  }
  return (
    <div style={{ width: '100%' }}>
      <div className={cn('panel', { show: notification })}>
        <div className={cn('animateFlag', { visible: notification })}>
          <Flag
            success
            floating
            title={notification ? notification.title : ''}
            content={notification ? notification.content : ''}
            actionable
            engageCaption={notification ? notification.ctaText : ''}
            engageProps={{
              onClick: () => {
                if (notification) {
                  setNotification(null);
                  clearHistoryNotificationState(history);
                  history.push(`${path}/${notification.animatedIconId}`);
                }
              },
            }}
            onDismiss={() => {
              setNotification(null);
              clearHistoryNotificationState(history);
            }}
          />
        </div>
      </div>
      <div className={styles.homePageContainer}>
        <div className={cn(styles.topBarContainer, 'shadowLow')}>
          <div className={styles.topBar}>
            <div className={styles.headerContainer}>
              <h3 className={styles.heading}>Animated Icons</h3>
              <div className={styles.buttonContainer}>
                <ConfigProvider
                  configKey={configKeys.IS_CREATE_ANIMATED_ICON_ENABLED}>
                  <Permission action={actions.CREATE_ANIMATED_ICON}>
                    <Button
                      onClick={() => {
                        history.push(`${path}/${routes.CREATE}`);
                      }}>
                      Add animated icon
                    </Button>
                  </Permission>
                </ConfigProvider>
              </div>
            </div>
            <Search
              onChange={(e) => {
                filter(e.target.value);
              }}
              size='m'
              placeholder='Search for animated icons by key or name'
              stretch
            />
          </div>
        </div>
        <div className={styles.gridContainer}>
          {filteredAnimatedIcons.length > 0 ? (
            <div className={styles.grid}>
              {filteredAnimatedIcons.map((doc) => getAnimatedIconItem(doc))}
            </div>
          ) : !_.isEmpty(filterString) ? (
            <NoSearchResultsFound searchQuery={filterString} />
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default AnimatedIconHomePage;
